import loadableWithRetry from '../common/loadableWithRetry'

const ContactForm = loadableWithRetry(() => import('./ContactForm'))

export default ContactForm;
